export interface SpriteDefinition {
  start: number;
  duration: number;
}

export const sfxSpriteConfig: Record<string, SpriteDefinition> = {
  roll_dice_1: { start: 0, duration: 2194 },
  roll_dice_2: { start: 2294, duration: 3317 },
  roll_dice_3: { start: 5711, duration: 3317 },
  deal_card_0: { start: 9128, duration: 139 },
  deal_card_1: { start: 9367, duration: 187 },
  deal_card_2: { start: 9654, duration: 158 },
  deal_card_3: { start: 9912, duration: 157 },
  deal_card_4: { start: 10169, duration: 149 },
  deal_card_5: { start: 10418, duration: 118 },
  deal_card_6: { start: 10636, duration: 148 },
  deal_card_7: { start: 10884, duration: 155 },
  deal_card_8: { start: 11139, duration: 125 },
  deal_card_9: { start: 11364, duration: 155 },
  deal_card_10: { start: 11619, duration: 150 },
  deal_card_11: { start: 11869, duration: 238 },
  deal_card_12: { start: 12207, duration: 131 },
  deal_card_13: { start: 12438, duration: 229 },
  deal_card_14: { start: 12767, duration: 143 },
  deal_card_15: { start: 13010, duration: 206 },
  deal_card_16: { start: 13316, duration: 197 },
  deal_card_17: { start: 13613, duration: 147 },
  deal_card_18: { start: 13860, duration: 153 },
  deal_card_19: { start: 14113, duration: 161 },
  deal_card_20: { start: 14374, duration: 182 },
  deal_card_21: { start: 14656, duration: 161 },
  deal_card_22: { start: 14917, duration: 495 },
  deal_card_23: { start: 15512, duration: 497 },
  deal_card_24: { start: 16109, duration: 179 },
  deal_card_25: { start: 16388, duration: 209 },
  deal_card_26: { start: 16697, duration: 168 },
  deal_card_27: { start: 16965, duration: 171 },
  deal_card_28: { start: 17236, duration: 182 },
  card_flip: { start: 17518, duration: 757 },
  page_turn_1: { start: 18375, duration: 1517 },
  page_turn_2: { start: 19992, duration: 1517 },
  page_turn_3: { start: 21609, duration: 1576 },
  page_turn_4: { start: 23285, duration: 2600 },
  page_turn_5: { start: 25985, duration: 2187 },
  chapter_complete: { start: 28272, duration: 11154 },
  new_card_available: { start: 39526, duration: 7262 },
  typing: { start: 46888, duration: 2233 },
  ui_window_open: { start: 49221, duration: 634 },
  ui_window_close: { start: 49955, duration: 655 },
  press_enter: { start: 50710, duration: 403 },
};

export const sfxActionMap: Record<string, string[]> = {
  roll_dice: ['roll_dice_1', 'roll_dice_2', 'roll_dice_3'],
  deal_card: ['deal_card_0', 'deal_card_1', 'deal_card_2', 'deal_card_3', 'deal_card_4', 'deal_card_5', 'deal_card_6', 'deal_card_7', 'deal_card_8', 'deal_card_9', 'deal_card_10', 'deal_card_11', 'deal_card_12', 'deal_card_13', 'deal_card_14', 'deal_card_15', 'deal_card_16', 'deal_card_17', 'deal_card_18', 'deal_card_19', 'deal_card_20', 'deal_card_21', 'deal_card_22', 'deal_card_23', 'deal_card_24', 'deal_card_25', 'deal_card_26', 'deal_card_27', 'deal_card_28'],
  card_flip: ['card_flip'],
  page_turn: ['page_turn_1', 'page_turn_2', 'page_turn_3', 'page_turn_4', 'page_turn_5'],
  chapter_complete: ['chapter_complete'],
  new_card_available: ['new_card_available'],
  typing: ['typing'],
  ui_window_open: ['ui_window_open'],
  ui_window_close: ['ui_window_close'],
  press_enter: ['press_enter'],
};

export type SFXAction = keyof typeof sfxActionMap;
